<div class="d-flex flex-column align-items-start align-self-stretch gap-4 p-3 w-100"
     style="background: var(--neutral-white, #FFF);">
    <div class="d-flex justify-content-between align-items-center align-self-stretch pb-3 border-bottom border-2">
      <div class="fs-5 fw-bold">Financials</div>
    </div>
    <div class="d-flex flex-row justify-content-end align-items-center w-100 gap-3">
      <app-saved-search #savedSearch [gridApi]="gridApi" [viewFilterType]="viewFilterType" [module]="module" (onClearFilters)="clearFiltersExternally()"></app-saved-search>
      <button (click)="exportFinancialCSV()" class="btn btn-secondary text-white">Export Csv</button>
    </div>
    <ag-grid-angular
      style="width: 100%; height: 500px;"
      class="ag-theme-alpine"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [rowSelection]="rowSelection"
      [rowData]="rowData"
      [pagination]="pagination"
      [sideBar]="sideBar"
      (dragStopped)="onColumnChange($event)"
      (filterChanged)="onColumnChange($event)"
      (columnVisible)="onColumnChange($event)"
      (sortChanged)="onColumnChange($event)"
      (gridReady)="onGridReady($event)">
    </ag-grid-angular>

    <div class="d-flex justify-content-end w-100">
      <div class="total-amount-display">
        Total Paid Amount: {{ totalPaidAmount | currency }}
      </div>
    </div>
  </div>
